var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map_tip_line",style:({ width: _vm.width + 'px', height: _vm.height + 'px' })},[_c('svg',{attrs:{"width":_vm.width + 'px',"height":_vm.height + 'px'}},[_c('line',{staticStyle:{"stroke":"#C18040","stroke-width":"2"},attrs:{"x1":"0","y1":"0","x2":_vm.width,"y2":_vm.height}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }